import React, { useMemo, useState, useEffect } from "react";
import { Flex, Loader } from "@fluentui/react-northstar";
import i18n from "../../helper/i18n";
import { useAiRoutes } from "../../App/useAiRoutes";
import "./index.css";
import { Subscription } from "../../components/Subscription/Subscription";

const ExamDashboard = (props) => {
  const userRole = props?.user?.role || "";
  const userEmail = props?.user?.mail || props?.user?.email || "";
  const { examDashboardData } = useAiRoutes(props.selectedExtension);

  const [iframeLoaded, setIframeLoaded] = useState(false);

  const getCurrentLanguage = () => {
    const languageMappings = {
      en: "en",
      "en-GB": "en",
      "en-US": "en",
      es: "es",
      pt: "pt",
      de: "de",
      fr: "fr",
      hi: "hi",
      it: "it",
      ja: "ja",
    };
    return languageMappings[i18n.language];
  };

  const currentLanguage = getCurrentLanguage();

  // ✅ show loader until examDashboardData is available
  const isDataLoading =
    !examDashboardData || Object.keys(examDashboardData).length === 0;

  const srcUrl = useMemo(() => {
    if (isDataLoading) return ""; // avoid loading iframe before data

    const base =
      "https://online-exam-system-hugaetc0e2eugmaf.canadacentral-01.azurewebsites.net/";
    const mode =
      (Object.keys(examDashboardData.additionalParams || {}).length &&
        (examDashboardData.additionalParams?.Mode ||
          examDashboardData.additionalParams?.mode)) ||
      "pre-prod";

    const normalizedSlug = props?.user?.slug?.replace(/^\?slug=/, "");
    const params = new URLSearchParams({
      slug: normalizedSlug || "",
      email: userEmail,
      language: currentLanguage,
      role: userRole,
      Mode: mode,
    });
    return `${base}?${params.toString()}`;
  }, [examDashboardData, userRole, userEmail, currentLanguage]);

  const postCrossDomainMessage = () => {
    const iframeEl = document.getElementsByClassName("exam-dashboard");
    iframeEl[0]?.contentWindow?.postMessage(
      {
        source: "examDashboard",
        message: { user: props?.user, isFromACV: true },
      },
      srcUrl
    );
  };

  useEffect(() => {
    if (iframeLoaded && !isDataLoading) {
      postCrossDomainMessage();
    }
  }, [iframeLoaded, isDataLoading]);

  const user =
    props?.user || JSON.parse(localStorage.getItem("userinfo")) || {};
  const dayRemaining = user?.dbData?.dayRemaining ?? 1;
  if (dayRemaining <= 0) {
    return (
      <Subscription
        pageName="examdash"
        isExpire={true}
        role={user?.role || ""}
      />
    );
  }

  return (
    <Flex column style={{ height: "calc(-60px + 100vh)" }}>
      <Flex style={{ flexGrow: 1, position: "relative" }}>
        {(!iframeLoaded || isDataLoading) && (
          <Flex
            style={{
              position: "absolute",
              inset: 0,
              background: "#fff",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 2,
            }}
          >
            <Loader />
          </Flex>
        )}

        {!isDataLoading && (
          <iframe
            src={srcUrl}
            className="exam-dashboard"
            allow="fullscreen; camera; microphone; clipboard-read; clipboard-write"
            title="Exam Dashboard"
            onLoad={() => setIframeLoaded(true)}
          />
        )}
      </Flex>
    </Flex>
  );
};

export default ExamDashboard;
